import './app-core.js';
require('./rcmc/sliders/featured-carousel');
require('./rcmc/nav-dropdown');
require('./app/blocks/doctors-providers.js');
